import { render, staticRenderFns } from "./TransactionItem.vue?vue&type=template&id=7618ccc1&"
import script from "./TransactionItem.vue?vue&type=script&lang=js&"
export * from "./TransactionItem.vue?vue&type=script&lang=js&"
import style0 from "./TransactionItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports